module.exports = __webpack_public_path__ + "img/ru_img2.8faebb2c.png";